module.exports = "/assets/landing-common/mission/photo@2x.jpg?aIGRJXI";